import { render, staticRenderFns } from "./receiptList.vue?vue&type=template&id=b08d2050&scoped=true"
import script from "./receiptList.vue?vue&type=script&lang=js"
export * from "./receiptList.vue?vue&type=script&lang=js"
import style0 from "./receiptList.vue?vue&type=style&index=0&id=b08d2050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08d2050",
  null
  
)

export default component.exports